module.exports = __webpack_public_path__ + "assets/img/live32.39fd806a.png";